import { render, staticRenderFns } from "./MarcomBookingOverview.vue?vue&type=template&id=4f84ee8c&scoped=true&"
import script from "./MarcomBookingOverview.vue?vue&type=script&lang=js&"
export * from "./MarcomBookingOverview.vue?vue&type=script&lang=js&"
import style0 from "./MarcomBookingOverview.vue?vue&type=style&index=0&id=4f84ee8c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f84ee8c",
  null
  
)

export default component.exports